
    <!--
 * 竖版-页面背景
 * @LastEditTime: Mon Aug 05 2024 21:41:13 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_26FL21"  :class="[`${ pageData.isEdit ? '' : 'full' }`,`normal`,`u_c_26FL21`]" ></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{},"zh-CN":{},"zh-TW":{},"en-US":{},"ja-JP":{},"ko-KR":{},"th-TH":{},"vi-VN":{},"de-DE":{},"fr-FR":{},"ru-RU":{},"es-ES":{},"pt-PT":{},"it-IT":{},"tr-TR":{},"pl-PL":{},"id-ID":{},"ar-SA":{}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    ;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.zh-CN{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.zh-TW{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.en-US{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.ja-JP{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.ko-KR{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.th-TH{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.vi-VN{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.de-DE{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.fr-FR{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.ru-RU{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.es-ES{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.pt-PT{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.it-IT{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.tr-TR{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.pl-PL{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.id-ID{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}.ar-SA{
.u_c_26FL21.normal{
position:absolute;
width:10.00rem;
height:70.85rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/05/1716776413598-72.png);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}

.u_c_26FL21.normal.full{
height:100%;

}
}
</style>
